module.exports = __webpack_public_path__ + "e2c84a6df8d343bee5db5292e2821469.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/video.png
 ** module id = 1549
 ** module chunks = 0
 **/